export default '/static/frontend/ReachDigital/12gobiking/dist/assets/sofort-6474b28d.svg'